import React from 'react';
import {classes, style, vars} from './doppe-page-desktop-background-view.st.css';
import {
    BymoPageBackgroundImageLayout,
    BymoPageBackgroundMediaSettingsDefaultValues,
    doppeHideableValueGetVisibleValue,
    useBymoPageProps
} from "../../client-server-common";
import {
    evaluateFunction,
    HtmlObjectHorizontalPosition,
    HtmlObjectResizeMode,
    HtmlObjectVerticalPosition
} from "@wix/devzai-utils-common";
import {wixImageResourceGetUrl, wixMediaResourceIsWixImageResource} from "@wix/devzai-common-wix";
import {BymoPageLayout} from "../bymo-page-style/bymo-page-style";
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";
import {cssBymoPageViewerFixedFullSizeElement} from "../bymo-page-viewer/bymo-page-viewer-css-utils";

export const DoppePageDesktopBackgroundView = React.memo(function DoppePageDesktopBackgroundView (props: DoppePageDesktopBackgroundView.Props) {
    const {
        className,
        ...htmlAttributes
    } = props;

    const bymoPageProps = useBymoPageProps();

    const backgroundImage = doppeHideableValueGetVisibleValue(
        bymoPageProps.desktopBackgroundImage,
        null);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className, cssBymoPageViewerFixedFullSizeElement())}
        >
            {evaluateFunction(() => {
                if (backgroundImage) {

                    const mediaInfo = backgroundImage.mediaInfo;

                    if (wixMediaResourceIsWixImageResource(mediaInfo)) {
                        const layout = backgroundImage.layout ?? BymoPageBackgroundImageLayout.Fill;

                        if (layout === BymoPageBackgroundImageLayout.Tile) {
                            return (
                                <div
                                    className={style(classes.tileBackgroundImage, {})}
                                    style={{
                                        [vars.tileLayoutSize]: backgroundImage.tileLayoutSize ?? BymoPageBackgroundMediaSettingsDefaultValues.tileLayoutSize,
                                        backgroundImage: `url(${wixImageResourceGetUrl(mediaInfo)})`,
                                        backgroundRepeat: 'repeat',
                                        opacity: backgroundImage.opacity ? backgroundImage.opacity / 100 : 1,
                                        backgroundPositionX: backgroundImage.tileHorizontalPosition ?? BymoPageBackgroundMediaSettingsDefaultValues.tileHorizontalPosition
                                    }}
                                />
                            )
                        }
                    }

                    return (
                        <DoppePageMediaView
                            className={style(classes.backgroundImage, {})}
                            mediaResource={mediaInfo}
                            layoutSpec={{dynamicHeight: true}}
                            widthSpec={
                                layout => layout === BymoPageLayout.Wide ?
                                    {screenRelativeWidth: 1} :
                                    {hidden: true}
                            }
                            mediaResizeMode={HtmlObjectResizeMode.Cover}
                            mediaVerticalPosition={backgroundImage.verticalPosition ?? HtmlObjectVerticalPosition.Center}
                            mediaHorizontalPosition={backgroundImage.horizontalPosition ?? HtmlObjectHorizontalPosition.Center}
                            style={{
                                opacity: backgroundImage.opacity !== undefined ? backgroundImage.opacity / 100 : 1
                            }}
                        />
                    )
                } else {
                    return null;
                }
            })}
        </div>
    );
});

export namespace DoppePageDesktopBackgroundView {

    export interface Props extends React.HTMLAttributes<any> {

    }
}